import { Icon, Tooltip } from '@chakra-ui/react';
import { PiCheckCircle, PiWarningCircle } from 'react-icons/pi';
import { OnboardType } from '../../../../../models/users';

enum OnboardStatusBadgeColor {
  PENDING = 'gray.400',
  PARTIAL = 'yellow.400',
  COMPLETED = 'green.400',
}

enum OnboardStatusTooltipLabel {
  'PENDING' = 'Pendente',
  'PARTIAL' = 'Parcial',
  'COMPLETED' = 'Completado',
}

interface IOnboardStatusBadgeProps {
  onboardType: OnboardType;
}

const OnboardStatusBadge = ({
  onboardType,
}: IOnboardStatusBadgeProps): JSX.Element => (
  <Tooltip
    placement="bottom"
    hasArrow
    label={OnboardStatusTooltipLabel[onboardType]}
  >
    <span>
      <Icon
        as={onboardType === 'COMPLETED' ? PiCheckCircle : PiWarningCircle}
        color={OnboardStatusBadgeColor[onboardType]}
        fontSize={26}
        cursor="pointer"
      />
    </span>
  </Tooltip>
);

export default OnboardStatusBadge;
